import { useEffect, useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";

export const FooterNewsletter = () => {
  const { lang } = useLanguage();
  const fr = lang === "fr";
  const [on, setOn] = useState(false);
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get("/site/footer-newsletter").then(({ data }) => setOn(data.enabled)).catch(() => {}); }, []);
  if (!on) return null;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/subscribe/footer", { email, lang, website: hp }); setDone(true); setEmail(""); }
    catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-6" data-testid="footer-newsletter">
      <h4 className="font-semibold mb-2 text-sm uppercase tracking-wider text-slate-400">{fr ? "Infolettre" : "Newsletter"}</h4>
      {done ? (
        <p className="text-sm text-emerald-300" data-testid="footer-newsletter-done">{fr ? "Merci ! Vous êtes inscrit à l'infolettre." : "Thanks! You're on the newsletter list."}</p>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          <p className="text-sm text-slate-300">{fr ? "Nouvelles, conseils et nouveaux animaux, de temps en temps." : "News, tips and new pets, now and then."}</p>
          <input tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden="true" name="website" />
          <div className="flex gap-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={fr ? "votre@courriel.ca" : "you@email.com"}
              className="flex-1 min-w-0 h-10 rounded-xl bg-white/10 border border-white/15 px-3 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-[#F5551E]" data-testid="footer-newsletter-email" />
            <button type="submit" disabled={busy} className="h-10 px-4 rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white text-sm font-semibold inline-flex items-center gap-1.5 transition-colors" data-testid="footer-newsletter-submit">
              {busy ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} {fr ? "S'inscrire" : "Join"}
            </button>
          </div>
          <p className="text-[11px] text-slate-400">{fr ? "Désabonnement en un clic en tout temps." : "Unsubscribe with one click any time."}</p>
        </form>
      )}
    </div>
  );
};
